import React, { useContext } from "react";
import { MemoContext } from "../../contexts/MemoContext";
import EmptyMemo from "../../components/EmptyMemo";
import MemoItem from "../../components/MemoItem";
import Masonry from "react-masonry-css";
import { Spin } from "antd";

const DashIndex = () => {
  const { memoData, status } = useContext(MemoContext);
  return (
    <div className="w-full h-full overflow-scroll p-5">
      {status === "found" ? (
        <Masonry
          breakpointCols={4}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {memoData.map((e) => {
            return (
              <MemoItem
                key={e.mid}
                mid={e.mid}
                content={e.memo_content}
                tags={e.tags}
                created={e.created}
                fav={e.fav}
                updated={e.updated}
              />
            );
          })}
        </Masonry>
      ) : status === "x" ? (
        <div className="w-full h-full flex flex-col justify-center items-center">
          <EmptyMemo />
        </div>
      ) : (
        <div className="h-full w-full flex justify-center items-center">
          {status === "load" ? <Spin size="large" /> : <EmptyMemo />}
        </div>
      )}
    </div>
  );
};

export default DashIndex;
